import React from 'react';
import PropTypes from '../../utils/PropTypes';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: 'h-6 w-6',
};

const ToolIcon = ({ className }) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
    >
        <path
            d="M17 12.014l-4.556-1.966c-.206-.089-.425-.146-.647-.17l-.452-.047-1.229-1.082.324-.749 1.647.116.344.297c.17.146.355.25.561.339l1.961.857 2.047 2.405zm-2.025-6.943c-.579-.679-1.428-1.071-2.321-1.071h-1.302l6.91 7.995h2.738l-6.025-6.924zm.707 1.956c-.099.083-.245.072-.329-.027l-1.048-1.233c-.084-.098-.072-.245.026-.329.098-.083.245-.071.328.027l1.049 1.233c.083.099.071.246-.026.329zm-12.682 4.969l2.215-.001 1.503-2.299c.16-.245.42-.408.711-.445.549-.072 1.065-.373 1.393-.874.426-.651.416-1.461.042-2.086l-.969 1.48c-.472.128-1.366-.456-1.437-.939l.969-1.48c-.724-.092-1.47.223-1.896.874-.327.5-.397 1.094-.242 1.626.082.281.036.584-.124.829l-2.165 3.315zm18 4.004c.552 0 1 .449 1 1s-.448 1-1 1h-18c-.552 0-1-.449-1-1s.448-1 1-1h18zm0-2h-18c-1.657 0-3 1.343-3 3s1.343 3 3 3h18c1.657 0 3-1.343 3-3s-1.343-3-3-3z"
            fill="currentColor"
        />
    </svg>
);

ToolIcon.propTypes = propTypes;
ToolIcon.defaultProps = defaultProps;

export default React.memo(ToolIcon);
